import axios from 'axios'
import config from '../config'

const getAll = () => {
  return axios.get(`${config.baseUrl}/paymentbank`, {
    headers: {
      'Authorization': `Bearer ${ sessionStorage.getItem('MonteVerdeToken') }`,
    },
  })
}

const getById = id => {
  return axios.get(`${config.baseUrl}/paymentbank/${id}`, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
    },
  })
}

const createPaymentBank = pb => {
  return axios.post(`${config.baseUrl}/paymentbank`, pb, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
    },
  })
}

const updatePaymentBank = (paymentBankId, updates) => {
  return axios.put(`${config.baseUrl}/paymentbank/${paymentBankId}`, updates, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('MonteVerdeToken')}`,
    },
  })
}

export default { getAll, getById, createPaymentBank, updatePaymentBank }
